import { render, staticRenderFns } from "./formalUpgradeTaskInfo.vue?vue&type=template&id=10040f00&scoped=true&"
import script from "./formalUpgradeTaskInfo.vue?vue&type=script&lang=js&"
export * from "./formalUpgradeTaskInfo.vue?vue&type=script&lang=js&"
import style0 from "./formalUpgradeTaskInfo.vue?vue&type=style&index=0&id=10040f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10040f00",
  null
  
)

export default component.exports